/* ===========================================================================
   Wasserquelle Theme – Interaktionen
   ---------------------------------------------------------------------------
   Ersetzt Framer Motion aus der Next.js-Demo:
     - Scroll-Reveal   -> IntersectionObserver + CSS-Transition
     - Header-Zustand  -> data-scrolled
     - Mobiles Menue   -> Klassenwechsel mit gestaffelten Transition-Delays
     - Technologie-Rail-> Fuellung per CSS-Transform
     - Hero-Video      -> Start/Pause nach Bewegungswunsch, Datensparen
                          und Sichtbarkeit; Pause-/Play-Knopf

   Die Tailwind-Klassen in dieser Datei werden vom Build mitgelesen
   (@source ".../assets/*.js"), sie muessen daher vollstaendig ausgeschrieben
   bleiben und duerfen nicht zusammengesetzt werden.
   =========================================================================== */

(function () {
  'use strict';

  var BAR_TOP_OPEN = 'translate-y-[3px] rotate-45';
  var BAR_BOTTOM_OPEN = '-translate-y-[3px] -rotate-45';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------- Scroll-Reveal ---------------------------- */

  var revealObserver = null;

  function revealNow(el) {
    el.classList.add('is-revealed');
  }

  function initReveals(root) {
    var targets = (root || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
    var pipes = (root || document).querySelectorAll('[data-pipe]:not(.is-revealed)');
    var all = [];
    Array.prototype.push.apply(all, targets);
    Array.prototype.push.apply(all, pipes);

    if (!all.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      all.forEach(revealNow);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealNow(entry.target);
            revealObserver.unobserve(entry.target);
          });
        },
        // Entspricht dem viewport-margin der Demo: -12% oben, -8% unten.
        { rootMargin: '-12% 0px -8% 0px', threshold: 0 }
      );
    }

    all.forEach(function (el) {
      // Bereits sichtbare Elemente sofort zeigen, damit oberhalb des Falzes
      // nichts leer bleibt, falls der Observer zu spaet greift.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        window.requestAnimationFrame(function () {
          revealNow(el);
        });
        return;
      }
      revealObserver.observe(el);
    });
  }

  /* -------------------------------- Header -------------------------------- */

  function initHeader(root) {
    var header = (root || document).querySelector('[data-header]');
    if (!header || header.dataset.bound === 'true') return;
    header.dataset.bound = 'true';

    function onScroll() {
      header.setAttribute('data-scrolled', window.scrollY > 24 ? 'true' : 'false');
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----------------------------- Mobiles Menue ---------------------------- */

  function initMenu(root) {
    var scope = root || document;
    var toggle = scope.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu || toggle.dataset.bound === 'true') return;
    toggle.dataset.bound = 'true';

    var barTop = toggle.querySelector('[data-bar-top]');
    var barBottom = toggle.querySelector('[data-bar-bottom]');
    var header = document.querySelector('[data-header]');
    var labelOpen = toggle.getAttribute('aria-label');
    var labelClose = toggle.getAttribute('data-label-close') || labelOpen;

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? labelClose : labelOpen);
      document.body.style.overflow = open ? 'hidden' : '';

      // Der Header bleibt bei geoeffnetem Menue deckend, wie in der Demo.
      if (header && open) header.setAttribute('data-scrolled', 'true');
      if (header && !open) header.setAttribute('data-scrolled', window.scrollY > 24 ? 'true' : 'false');

      if (barTop) BAR_TOP_OPEN.split(' ').forEach(function (c) { barTop.classList.toggle(c, open); });
      if (barBottom) BAR_BOTTOM_OPEN.split(' ').forEach(function (c) { barBottom.classList.toggle(c, open); });
    }

    toggle.addEventListener('click', function () {
      setOpen(!menu.classList.contains('is-open'));
    });

    menu.querySelectorAll('[data-menu-close]').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false);
    });

    setOpen(false);
  }

  /* ------------------------------ Hero-Video ------------------------------ */

  // Bewegung ist erlaubt, wenn weder das Betriebssystem reduzierte Bewegung
  // wuenscht noch der Theme-Schalter "Animationen" ausgeschaltet ist.
  function bewegungErlaubt() {
    if (document.documentElement.classList.contains('wq-no-motion')) return false;
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Datensparmodus oder sehr langsame Verbindung: kein automatischer Start.
  function datenSparen() {
    var verbindung = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!verbindung) return false;
    if (verbindung.saveData) return true;
    return verbindung.effectiveType === 'slow-2g' || verbindung.effectiveType === '2g';
  }

  // Kleinste MP4-Variante, die die Flaeche scharf fuellt. object-cover
  // skaliert auf die groessere Seite; die Pixeldichte wird bei 2 gedeckelt.
  // Unter 768 px kommen nur Varianten bis 720p infrage – mobil hat das
  // Datenvolumen Vorrang vor der letzten Schaerfestufe.
  function waehleQuelle(video, quellen) {
    var sortiert = quellen.slice().sort(function (a, b) { return a.w - b.w; });
    if (window.innerWidth < 768) {
      var mobil = sortiert.filter(function (q) { return q.h && q.h <= 720; });
      if (mobil.length) sortiert = mobil;
    }
    var groesste = sortiert[sortiert.length - 1];
    var seitenverhaeltnis = groesste.w && groesste.h ? groesste.w / groesste.h : 16 / 9;
    var box = video.getBoundingClientRect();
    var dichte = Math.min(window.devicePixelRatio || 1, 2);
    var bedarf = Math.max(box.width, box.height * seitenverhaeltnis) * dichte;
    for (var i = 0; i < sortiert.length; i++) {
      if (sortiert[i].w >= bedarf) return sortiert[i].u;
    }
    return groesste.u;
  }

  function initHeroVideos(root) {
    document.documentElement.classList.toggle(
      'wq-hero-overlay',
      !!document.querySelector('[data-hero-overlay]')
    );

    (root || document).querySelectorAll('[data-hero-video]').forEach(function (video) {
      if (video.dataset.bound === 'true') return;
      video.dataset.bound = 'true';

      var quellen;
      try {
        quellen = JSON.parse(video.dataset.sources || '[]');
      } catch (e) {
        quellen = [];
      }
      if (!quellen.length) return;

      var knopf = video.parentElement.querySelector('[data-hero-video-toggle]');
      var geladen = false;
      // soll: ob das Video laufen soll, sobald es sichtbar ist. Startwert aus
      // den Voreinstellungen, danach entscheidet allein der Knopf.
      var soll = bewegungErlaubt() && !datenSparen();

      // Zusaetzlich zum Attribut: Safari blockiert Autoplay sonst mitunter.
      video.muted = true;

      function zeigeZustand(spielt) {
        if (!knopf) return;
        knopf.setAttribute('data-state', spielt ? 'playing' : 'paused');
        knopf.setAttribute('aria-label', spielt ? knopf.dataset.labelPause : knopf.dataset.labelPlay);
      }

      function spiele() {
        if (!geladen) {
          geladen = true;
          video.src = waehleQuelle(video, quellen);
        }
        var versuch = video.play();
        // Abgelehnt, z. B. im iOS-Stromsparmodus: das Standbild bleibt stehen.
        if (versuch && typeof versuch.catch === 'function') {
          versuch.catch(function () { zeigeZustand(false); });
        }
      }

      video.addEventListener('playing', function () {
        video.setAttribute('data-playing', 'true');
        zeigeZustand(true);
      });
      video.addEventListener('pause', function () { zeigeZustand(false); });

      if (knopf) {
        zeigeZustand(false);
        knopf.hidden = false;
        knopf.addEventListener('click', function () {
          if (video.paused) {
            soll = true;
            spiele();
          } else {
            soll = false;
            video.pause();
          }
        });
      }

      if (!('IntersectionObserver' in window)) {
        if (soll) spiele();
        return;
      }

      var beobachter = new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (eintrag) {
            if (eintrag.isIntersecting) {
              if (soll && video.paused) spiele();
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.2 }
      );
      beobachter.observe(video.parentElement);
      video.wqBeobachter = beobachter;
    });
  }

  /* ------------------------------- Aufbau --------------------------------- */

  function init(root) {
    initHeader(root);
    initMenu(root);
    initReveals(root);
    initHeroVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Der Theme-Editor rendert einzelne Sections neu.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Beim Entfernen einer Section im Editor Video anhalten und Beobachter loesen.
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-hero-video]').forEach(function (video) {
      if (video.wqBeobachter) video.wqBeobachter.disconnect();
      video.pause();
    });
  });

  window.WQTheme = { init: init, initReveals: initReveals, initHeroVideos: initHeroVideos };
})();
